import {MedicationState} from "../../services/medicationmanagement/medications";
import {
    SelectableCriticalBadge,
    SelectableNewBadge
} from "../common/status-badge/StatusBadgeCheckbox";
import React from "react";


export const SelectableMedicationStatusBadge=(props:{
    medicationState:MedicationState;
    checked?:boolean;
    onChange: ()=>void;
})=>{
    switch (props.medicationState) {
        case MedicationState.New:
            return <SelectableNewBadge checked={props.checked} onChange={props.onChange} label="New"/> 
        case MedicationState.RePrescribed:
                return <SelectableNewBadge checked={props.checked} onChange={props.onChange} label="Re-prescribed"/>    
        case MedicationState.Ceased:
            return <SelectableCriticalBadge checked={props.checked} onChange={props.onChange} label="Ceased"/>
        case MedicationState.Existing:
            return null;
        case MedicationState.Expired:
            return null;
    }
};